import styled from 'styled-components';
import { colors } from 'globalStyles';
import { media } from 'utils/style-utils'

export const Wrapper = styled.div`
	display: flex;
	justify-content: center;
`;

export const Text = styled.p`
  padding-left: 20px;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 4px;
  color: ${colors.BODY};

  ${media.mobile`
    display: none;
  `}

`;



// WEBPACK FOOTER //
// ./src/components/Logo/styledComponents.js